import React from "react";
import FancyLink from "../_shared/FancyLink";
import s from "./Links.module.css";
import Spacing from "../_shared/Spacing";

function Links({ links, spacing }) {
  return (
    <Spacing value={spacing}>
      <div className={s.links}>
        {links.map((l, idx) => (
          <FancyLink key={`${idx}-${l.id}`} {...l} />
        ))}
      </div>
    </Spacing>
  );
}

export default Links;
